function setSlide(slideId) {
  slides.forEach(slide => slide.classList.remove('active'));
  [...slides][slideId].classList.add('active');
}

let slides;
function configureSlider(sliderElement) {
  if (!sliderElement) return;

  let currentSlide = 0;
  slides = sliderElement.querySelectorAll('.rsContent');
  slides.forEach(slide => {
    const linkElement = slide.querySelector('a');
    const bgUrl = linkElement.href;
    const imgElement = document.createElement('img');
    imgElement.src = bgUrl;
    imgElement.style.width = '100%';
    imgElement.style.height = '100%';
    imgElement.style.objectFit = 'cover';
    imgElement.style.objectPosition = 'center';
    linkElement.after(imgElement);
    linkElement.remove();
  });

  setSlide(currentSlide);
  setInterval(() => {
    if (slides === undefined) return;
    currentSlide = (currentSlide + 1) % slides.length;
    setSlide(currentSlide);
  }, 3000);
}

configureSlider(document.querySelector('.royalSlider'));

